

function fraudRiskManagement() {

  let FraudRiskManagement = [
    {
      name: "Fraud & Risk Management",
      icon: "Fraud & Risk Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "wallet",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/fraud&risk-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const riskRules = () => {
    const profileArr = [
      {
        path: "/index/risk-rules",
        name: "Risk Rules",
        icon: "RiskRules",
        logoName: "riskrules",
        flag: "RISK RULE",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const blockCountry = () => {
    const mybanksArr = [
      {
        path: "/index/block-country",
        name: "Block Country",
        icon: "block-country",
        logoName: "block country",
        flag: "BLOCK COUNTRY",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const allowCountry = () => {
    const mycardsArr = [
      {
        path: "/index/allow-country",
        name: "Allow Country",
        icon: "allow-country",
        logoName: "country1",
        flag: "ALLOW COUNTRY",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  let a = dashboard();
  let b = riskRules();
  let c = blockCountry();
  let d = allowCountry();
  FraudRiskManagement[0].items = [...a, ...b, ...c, ...d];

  return FraudRiskManagement;
}

export default fraudRiskManagement;
